module.exports = __webpack_public_path__ + "img/img_3.3cc166b3.png";